import { SaveButton } from 'components/ActionButton'
import IconWrapper from 'components/IconWrapper'
import { ButtonsContainer, ModalHeader, ModalWrapper } from 'components/Modal'
import { CancelButton } from 'components/PageStructure'
import { useModalContext } from 'providers/Overlays/ModalProvider'
import { Slash } from 'react-feather'
import styled from 'styled-components'
import { bodyPrimaryColor } from 'styles/styleVariables'

type Props = {
  actionsLabel: string
  orderCount: number
  onConfirm: () => void
}

const AbortBulkActionModal = ({ actionsLabel, orderCount, onConfirm }: Props): JSX.Element => {
  const { dismissModal } = useModalContext()

  const handleConfirm = () => {
    onConfirm()
    dismissModal()
  }

  return (
    <ModalWrapper id="AbortBulkActionModal">
      <ModalHeader>
        <IconWrapper>
          <Slash stroke={bodyPrimaryColor} />
        </IconWrapper>
        <h2>Abort Bulk Action</h2>
      </ModalHeader>
      <ConfirmationText>
        Stop <strong>{actionsLabel}</strong> for <strong>{orderCount} orders</strong>? Already processed orders will
        keep their results.
      </ConfirmationText>
      <ButtonsContainer>
        <CancelButton label="Keep running" onClick={dismissModal} />
        <SaveButton label="Abort" isModal onClick={handleConfirm} />
      </ButtonsContainer>
    </ModalWrapper>
  )
}

export default AbortBulkActionModal

const ConfirmationText = styled.p`
  max-width: 36rem;
  margin: 0.75rem 0;
  font-size: 1rem;
  line-height: 1.5;
`
